/**
 * <TutorCharterStep> — « Lis et approuve la charte d'engagement du tuteur » (organism).
 *
 * La charte se lit dans l'étape, sans un toucher (Wajih, 03/11) : la page du site dans son cadre
 * (`<WebFrame>`, une iframe au web, une WebView au téléphone), comme l'ancien parcours. Dessous, la
 * case du design system, « J'accepte la charte d'engagement du tuteur » ; tant qu'elle n'est pas
 * cochée, l'étape ne se valide pas (`<TutorCompleteProfilePage>`). La page reste celle du site :
 * la charte change sans version de l'app.
 */
import React from "react"

import { Checkbox } from "../../atoms/Checkbox"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../../molecules/Card"
import { WebFrame } from "../../molecules/WebFrame"

export type TutorCharterStepProps = {
    charterUrl: string
    accepted: boolean
    onToggleAccepted: (next: boolean) => void
    error?: string | null
    disabled?: boolean
    testID?: string
}

const TEXTS = {
    frame: "Charte d'engagement du tuteur",
    loading: "Chargement de la charte…",
    accept: "J'accepte la charte d'engagement du tuteur",
}

/** Assez pour lire une section entière sans quitter l'étape ; la page défile dans son cadre. */
const CHARTER_HEIGHT = 440

export function TutorCharterStep(props: TutorCharterStepProps) {
    const { charterUrl, accepted, onToggleAccepted, error, disabled, testID } = props

    return (
        <Stack gap="4" testID={testID}>
            <WebFrame url={charterUrl} height={CHARTER_HEIGHT} title={TEXTS.frame} loadingLabel={TEXTS.loading} />
            <Card p="4">
                <Checkbox checked={accepted} onChange={onToggleAccepted} label={TEXTS.accept} disabled={disabled} />
            </Card>
            {error != null && error !== "" && (
                <Text size="text-md" color="danger-strong">
                    {error}
                </Text>
            )}
        </Stack>
    )
}
